





























import { Component, Vue, Watch } from 'vue-property-decorator';
import MarkdownIt from 'markdown-it';

@Component({})
export default class LogList extends Vue {
  private logs: any = [];
  private gists: any = [];
  private logIdx = 0;
  private log: any = {};
  private canRender = false;

  @Watch('$route')
  onRouteChange(to: any, from: any){
    const idx = to.query.post;

    if(idx){
      this.goToLog(idx);
    }else{
      this.logIdx = 0;
    }
  }

  // When the page is mounted...
  mounted(){

    const lsLogs = window.localStorage.getItem('logs');
    const urlParams = new URLSearchParams(window.location.search);
    const idx = urlParams.get('post');

    if(lsLogs){
      // A) Check if there are logs set in local storage.
      const dateDiff = this.parseDate();

      // Check if the last time the client fetched the API was over a day ago.
      if(dateDiff){
        // If so fetch a fresh list of gists.
        this.getGists();
      }else{
        // Else use the browser cache.
        this.logs = JSON.parse(lsLogs);
      }
    }else{
      // B) Otherwise fetch the Gists
      this.getGists();
    }

    this.logIdx = parseInt(idx as string);

    setTimeout(()=>{
      if(this.logs[this.logIdx-1]){
        this.goToLog(idx);
      }
    }, 1000);
  }

  getGists(){
    fetch('https://api.github.com/users/plachenko/gists').then(response => response.json()).then( data => this.setLogs(data))
  }

  getPost(url: string){
    fetch(url).then(response => response.json()).then( data => {
      const content = data.files[Object.keys(data.files)[0]].content;
      this.logs[this.logIdx-1].body = MarkdownIt({html: true}).render(content);
      this.saveLogs(this.logs);
      this.canRender = true;
    })
  }

  goToLog(idx: any){
    if(idx){
      this.log = this.logs[idx-1];

      if(!this.log.body.length){
        this.getPost(this.log.url);
      }else{
        this.canRender = true;
      }
    }
  }

  setLogURL(idx = 0){
    this.$router.push(`/log?post=${idx}`);
    this.goToLog(idx);
    this.logIdx = idx;
  }

  // Save logs and current date to local storage.
  saveLogs(logs: any){
    const date = new Date();
    window.localStorage.setItem('logs', JSON.stringify(logs));
    window.localStorage.setItem('lastDate', JSON.stringify(date));
  }

  parseDate(){
    const lsItem = window.localStorage.getItem('lastDate');
    const last = JSON.parse(lsItem as string);
    const lastDate = new Date(last).getTime();
    const now = Date.now();
    const dateDiff = Math.floor(((((now - lastDate) / 1000) / 60) / 60) / 24);

    return dateDiff;
  }

  // Set the local logs from a gist fetch.
  setLogs(gists: any[] = []){

    const logs: any = []

    // filter gists to look for logs specifically.
    const logFilter = gists.filter((log: any) => {
      return log.description.includes('LOG:');
    });

    this.gists = logFilter;


    logFilter.forEach((el: any, idx: number) => {
      const log = {
        title: '',
        date: '',
        url: '',
        body: ''
      };
      const date = el.created_at.slice(0,10).split('-');
      log.title = el.description.substr(5);
      log.date = date;
      log.url = el.url

      logs[(logFilter.length - 1) - idx] = log;
    });

    this.saveLogs(logs);
    this.logs = logs;

  }
}

